import { parseIsoDate } from '@/modules/dashboards/dashboardRanges';
import { PLATFORM_AUDIT_ACTIONS, type PlatformAuditAction } from '@/shared/api/platform';

/** `validateSearch` of `/platform/audit` (07 §4.3): every filter lives in the URL. */
export interface PlatformAuditSearch {
  platformAdminId?: string;
  tenantId?: string;
  action?: PlatformAuditAction;
  from?: string;
  to?: string;
}

function parseFreeText(value: unknown): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

export function platformAuditSearchSchema(search: Record<string, unknown>): PlatformAuditSearch {
  const result: PlatformAuditSearch = {};

  const platformAdminId = parseFreeText(search['platformAdminId']);
  if (platformAdminId !== undefined) {
    result.platformAdminId = platformAdminId;
  }

  const tenantId = parseFreeText(search['tenantId']);
  if (tenantId !== undefined) {
    result.tenantId = tenantId;
  }

  const action = search['action'];
  if (
    typeof action === 'string' &&
    PLATFORM_AUDIT_ACTIONS.includes(action as PlatformAuditAction)
  ) {
    result.action = action as PlatformAuditAction;
  }

  const from = parseIsoDate(search['from']);
  const to = parseIsoDate(search['to']);
  if (from !== undefined && to !== undefined) {
    result.from = from;
    result.to = to;
  }

  return result;
}
